import { Link, useLocation } from 'react-router-dom';
import { useEnrichedAuth } from '@/hooks/useEnrichedAuth';
import { ActsLogo } from '@/components/ui/ActsLogo';
import { SyncIndicator } from '@/components/sync/SyncIndicator';
import { AccountMenu } from './AccountMenu';
import { ThemeMenu } from './ThemeMenu';
import { hidesSignInLink } from './routes';

const NAV = [
  { to: '/', label: 'Procedures', active: (p: string) => p === '/' || p.startsWith('/p/') },
  { to: '/me/runs', label: 'My runs', active: (p: string) => p.startsWith('/me/') },
];

/**
 * Header band. Phones: Acts Church wordmark + "Procedures" on the left, then the sync status
 * (only while something is waiting to sync) and the theme button (signed out) or the avatar menu
 * (signed in). Desktop (769 px and up): the same band with text navigation.
 */
export function AppHeader() {
  const location = useLocation();
  const { isAuthenticated } = useEnrichedAuth();
  const path = location.pathname;
  const showSignIn = !isAuthenticated && !hidesSignInLink(path);

  return (
    <header className="proc-header">
      <div className="proc-header-inner">
        <Link to="/" className="proc-lockup" aria-label="Acts Procedures, all procedures">
          <ActsLogo height={22} alt="" />
          <span className="sep" aria-hidden="true" />
          <span className="name" aria-hidden="true">Procedures</span>
        </Link>
        {isAuthenticated && (
          <nav className="proc-desknav" aria-label="Main">
            {NAV.map((item) => {
              const on = item.active(path);
              return (
                <Link key={item.to} to={item.to} aria-current={on ? 'page' : undefined}>
                  {item.label}
                </Link>
              );
            })}
          </nav>
        )}
        <span className="grow" />
        <SyncIndicator />
        {isAuthenticated ? (
          <AccountMenu />
        ) : (
          <>
            {showSignIn && (
              <Link className="proc-headlink" to={`/auth/login?redirect=${encodeURIComponent(path + location.search)}`}>Sign in</Link>
            )}
            <ThemeMenu />
          </>
        )}
      </div>
    </header>
  );
}
